<template>
  <div class="p--40px">
    <strong class="font--21px font--600 pb--24px block">BANNER {{isEditMode ? '수정' : '생성'}}</strong>
    <form @submit.prevent="submit">

      <div class="myinfo__body admin--myinfo clear pt--24px">
        <div
          class="info__modified clearfix"
          @input="error.errorMessage = ''"
        >

          <text-field-toggle
            :error="error"
            v-model="row.useFlag"
            true-value="Y"
            false-value="N"
            label="노출여부"
            name="useFlag"
            help-text=""
          ></text-field-toggle>

          <text-field-input
            :required="true"
            :error="error"
            v-model="row.title"
            label="배너 제목"
            name="title"
            :placeholder="''"
            :readonly="isEditMode"
            :helpText="'제목은 배너 화면에 표시되는것이 아니라 게시글을 구분하기 위한 용도 입니다.'"
          ></text-field-input>

          <field-container
            label="배너 선택"
            :required="true"
          >
            <div class="clearfix">
              <form-error
                :error="error"
                name="files"
              ></form-error>

              <form-thum-file
                :name="'files-0'"
                :index="0"
                :error="error"
                url="/api/banners/files/"
                :uuid="row.uuid"
                :files="row.files"
                helpHtml="<strong class='pt--16px'>Desktop</strong><br>가로 1920px 세로 800px,<br>2MB 이하 권장"
                :limit="1"
                :accept="['.png', '.jpeg', '.jpg', '.gif', '.svg']"
                :uploadStatus="uploadStatus"
                @removeFile="removeFile"
                @error="onFileError"
                @fileUpload="onFileUpload"
              ></form-thum-file>

              <form-thum-file
                :name="'files-1'"
                :index="1"
                :error="error"
                url="/api/banners/files/"
                :uuid="row.uuid"
                :files="row.files"
                helpHtml="<strong class='pt--16px'>Mobile</strong><br>가로 640px<br>1MB 이하 권장"
                :limit="1"
                :accept="['.png', '.jpeg', '.jpg', '.gif', '.svg']"
                :uploadStatus="uploadStatus"
                @removeFile="removeFile"
                @error="onFileError"
                @fileUpload="onFileUpload"
              ></form-thum-file>
            </div>
          </field-container>

          <!-- <field-container
            label="배너 선택"
            :required="true"
          >
            <div class="inline-block clearfix mr--12px text--top">
              <form-files
                url="/api/banners/files/"
                :limit="1"
                :files="row.files1"
                :uuid="row.uuid"
                :error="error"
                name="files1"
                class="thum--desktop"
                extraClass="thum--desktop"
                @removeFile="removeFile1"
                @error="(err) => this.error = err"
              />
              <p class="font--14px clear">
                <strong class="pt--16px">Desktop</strong><br>가로 00px 세로 00px,<br>10MB 이하 권장
              </p>
            </div>
            <div class="inline-block clearfix mr--12px text--top">
              <form-files
                url="/api/banners/files/"
                :limit="1"
                :files="row.files2"
                :uuid="row.uuid"
                :error="error"
                name="files2"
                class="thum--mobile"
                extraClass="thum--mobile"
                @removeFile="removeFile2"
                @error="(err) => this.error = err"
              />
              <p class="font--14px clear">
                <strong class="pt--16px">Mobile</strong><br>가로 00px 세로 00px,<br>10MB 이하 권장
              </p>
            </div>
          </field-container> -->

          <text-field-input
            :required="false"
            :error="error"
            v-model="row.link"
            label="링크주소"
            name="link"
            placeholder="http:// 또는 https:// 필수 입력"
            helpText="배너 클릭시 이동할 주소를 입력해 주세요."
          ></text-field-input>

          <text-field-toggle
            :error="error"
            v-model="row.newWindowFlag"
            true-value="Y"
            false-value="N"
            label="새창여부"
            name="newWindowFlag"
            help-text=""
          ></text-field-toggle>
        </div>
        <div class="text--center py--40px">
          <form-button
            label="취소"
            class="btn btn--xxxl border border--gray mr--8px"
            @click="$router.go(-1)"
          ></form-button>
          <form-button
            type="submit"
            label="저장"
            class="btn btn--xxxl black text--white"
          ></form-button>
        </div>
      </div>
    </form>

  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
const uuidv1 = require('uuid/v1')

export default {
  data () {
    return {
      row: {
        seq: '',
        uuid: '',
        newWindowFlag: 'N',
        useFlag: 'Y',
        files: []
      },
      uploadStatus: '',
      origin: {},
      error: {}
    }
  },
  computed: {
    isEditMode () {
      return !!this.$route.params.seq
    }
  },
  async created () {
    const { seq } = this.$route.params
    if (seq) {
      await this.$load(`/api/banners/${seq}`)
      while (this.row.files.length < 2) {
        this.row.files.push({})
      }
    } else {
      this.row.uuid = `${moment().format('YYYYMMDD')}_${uuidv1()}`
      this.row.bannerType = this.$route.params.bannerType
    }
  },
  methods: {
    async submit () {
      try {
        if (!this.isEditMode) {
          await this.$create(`/api/banners`)
          this.$router.push({ name: 'adminBanner' })
        } else {
          await this.$update(`/api/banners/${this.row.seq}`)
          this.$router.go(-1)
        }
      } catch (error) {
        this.error = error
      }
    },
    onFileError (err) {
      console.log('err', err)
      this.error = err
    },
    removeFile (idx) {
      Vue.set(this.row.files, idx, {})
    },
    onFileUpload (uploadStatus) {
      this.uploadStatus = uploadStatus
    }
  },
  components: {
    FormButton: () => import('@/component/ui2/button/FormButton'),
    TextFieldInput: () => import('@/component/ui2/textfield/TextFieldInput'),
    // TextFieldSelect: () => import('@/component/ui2/textfield/TextFieldSelect'),
    TextFieldToggle: () => import('@/component/ui2/textfield/TextFieldToggle'),
    FormThumFile: () => import('@/component/ui2/form/FormThumFile'),
    FormError: () => import('@/component/ui2/form/FormError'),
    FieldContainer: () => import('@/component/ui2/uicontainer/FieldContainer')

  }
}
</script>
